import axios from "axios";
import Cookies from "js-cookie";
import { getApiUrl } from "./consts";

const apiUrl = getApiUrl();

const api = axios.create({
    baseURL: apiUrl,
    headers: {
        "Content-Type": "application/json",
    },
});


api.interceptors.request.use(
    (config) => {
        const token = Cookies.get("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // Логирование всех запросов
        const fullUrl = config.baseURL ? `${config.baseUpRL}${config.url}` : config.url;
        return config;
    },
    (error) => {
        console.error('[axiosConfig] Request error:', error);
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('[axiosConfig] Response error:', error.config?.method?.toUpperCase(), error.config?.url, error.message);
        console.error('[axiosConfig] Error details:', {
            message: error.message,
            code: error.code,
            request: error.config ? `${error.config.baseURL}${error.config.url}` : 'unknown',
            status: error.response?.status,
            statusText: error.response?.statusText
        });
        return Promise.reject(error);
    }
);

export default api;
